const SessionEvents = Object.freeze({
    // localMediaStreamConnected: 'localMediaStreamConnected',
    disconnected: 'disconnected',
    participantDisconnected: 'participantDisconnected',
    participantTrackAdded: 'participantTrackAdded',
    // participantJoined: 'participantJoined',
    signalRequired: 'signalRequired',
    nudgeReceived: 'nudgeReceived',
    inferenceReceived: 'inferenceReceived',
    webrtcIssue: 'webrtcIssue',
    webrtcNetworkScoreUpdated: 'webrtcNetworkScoreUpdated',
    webrtcQualityUpdated: 'webrtcQualityUpdated',
    connectSucceeded: 'connectSucceeded',
    aimeeEvent: 'aimeeEvent',

    // new - TODO
    // videoDeviceConnected: 'videoDeviceConnected',
    // videoDeviceDisconnected: 'videoDeviceDisconnected',
})

const SessionTypes = Object.freeze({
    meeting: "meeting",
    monitoring: "monitoring",
    test: "test"
})

const ParticipantTypes = Object.freeze({
    device: "device",
    kiosk: "kiosk",
    otherBrowserPeer: "otherBrowserPeer",
})

export { SessionEvents, SessionTypes, ParticipantTypes }